import { Component, Input } from '@angular/core';
import { FilterFieldValue } from './covance-filter.models';
import { MdlDialogService } from '@angular-mdl/core';
import { ChainNodeDialogComponent, ChainNodeDialogArgs, CHAIN_NODE_DIALOG_ARGS, ChainNodeDialogResult } from './chain-node-dialog.component';
import { FilteredEntityField } from './covance-chain-filter';
import { CovanceFilterChainNodeType, PositionType } from './filter-type/covance-filter-chain-node-type';

@Component({
    selector: 'covance-chain-filter',
    template: require('./covance-chain-filter.component.html'),
    styles: [require('./covance-chain-filter.component.scss')]
})
export class CovanceChainFilterComponent {
    @Input()
    public fieldVals: FilterFieldValue[] = [];

    @Input()
    public filteredEntityFields: FilteredEntityField<any>[];

    @Input()
    public enableAddPreFilter = true;

    @Input()
    public enableAddPostFilter = true;

    constructor(
        private dialogServce: MdlDialogService,
        private filterChainNodeType: CovanceFilterChainNodeType
    ) { }

    public async addPreFilter() {
        try {
            const newFieldVal = await this.createFilter(null);

            this.filterChainNodeType.setQueryParamValue(newFieldVal);
            this.filterChainNodeType.onFieldAdd(newFieldVal, PositionType.Pre);
        } catch (e) {
            console.debug(e);
        }
    }

    public async addPostFilter() {
        try {
            const newFieldVal = await this.createFilter(null);

            this.filterChainNodeType.setQueryParamValue(newFieldVal);
            this.filterChainNodeType.onFieldAdd(newFieldVal, PositionType.Post);
        } catch (e) {
            console.debug(e);
        }
    }

    private async createFilter(queryParam: string): Promise<FilterFieldValue> {
        const result = await this.openDialog();

        return this.filterChainNodeType.createFilterFieldValue(queryParam, result.title, result.fieldName);
    }

    private async openDialog(): Promise<ChainNodeDialogResult> {
        const model: ChainNodeDialogArgs = {
            fields: this.filteredEntityFields
        };

        const mdlDialogReference = await this.dialogServce.showCustomDialog({
            component: ChainNodeDialogComponent,
            providers: [
                {
                    provide: CHAIN_NODE_DIALOG_ARGS,
                    useValue: model
                }
            ],
            isModal: true
        }).toPromise();

        const result = await mdlDialogReference.onHide().toPromise<ChainNodeDialogResult>();

        if (!result) {
            return Promise.reject('Dialog has been cancelled.');
        }

        return result;
    }
}